module.exports = __webpack_public_path__ + "img/tuijian.ad7bc935.jpg";